import { render, staticRenderFns } from "./ProjectProfilesTabView.vue?vue&type=template&id=0d2bf406&"
import script from "./ProjectProfilesTabView.vue?vue&type=script&lang=ts&"
export * from "./ProjectProfilesTabView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports